// Mock data para UNKNOW Design Agency

export const mockServices = [
  {
    id: 1,
    title: "Brand Project",
    description: "From vision to launch — your brand, built from the ground up. We lead end-to-end branding projects with a clear strategy, defined roadmap, and structured timelines. Whether you're building a brand from scratch, rebranding, launching a new venture, or creating a distinctive event identity, we act as your outsourced branding team, guiding and executing every stage of the process.",
    image: "https://customer-assets.emergentagent.com/job_unknown-branding/artifacts/6u233s4j_BRAND%20PROJECT.png"
  },
  {
    id: 2,
    title: "Embedded Design Team",
    description: "Your brand, supported every day. A design studio integrated into your workflow. Hire UNKNOWN on a monthly basis and make us a true extension of your team. We manage weekly deliverables and collaborate closely with you to create visual assets that strengthen your communication strategy — staying agile, proactive, and fully aligned with your brand objectives.",
    image: "https://customer-assets.emergentagent.com/job_unknown-branding/artifacts/zq266blm_EMBEDDED%20DESIGN%20TEAM.png"
  },
  {
    id: 3,
    title: "Product Design",
    description: "Branded digital experiences for startups and tech-driven companies. We design websites, apps, and digital products through a strategic branding lens. By combining visual identity, user experience, and functional design, we create digital platforms that communicate purpose, drive engagement, and elevate your brand across every touchpoint.",
    image: "https://customer-assets.emergentagent.com/job_unknown-branding/artifacts/ocd6zyic_PRODUCT%20DESIGN.png"
  }
];

export const mockContactSubmit = (formData) => {
  // Mock function to simulate form submission
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log('Form submitted (MOCK):', formData);
      resolve({ success: true, message: 'Message sent successfully!' });
    }, 1000);
  });
};
